import React, { useState } from 'react';
import { InstagramIcon } from 'lucide-react';
import { useLanguage } from '../contexts/LanguageContext';
import { SectionHeading } from './SectionHeading';
import { BeforeAfter } from './BeforeAfter';
import { transformations, GalleryCategory } from '../data/gallery';
import { business } from '../data/business';
type Filter = 'all' | GalleryCategory;
export function Gallery() {
  const {
    t,
    lang
  } = useLanguage();
  const [filter, setFilter] = useState<Filter>('all');
  const filters: {
    id: Filter;
    label: string;
  }[] = [{
    id: 'all',
    label: t.gallery.filters.all
  }, {
    id: 'exterior',
    label: t.gallery.filters.exterior
  }, {
    id: 'interior',
    label: t.gallery.filters.interior
  }, {
    id: 'full',
    label: t.gallery.filters.full
  }];
  const visible = filter === 'all' ? transformations : transformations.filter(item => item.category === filter);
  return <section id="gallery" className="bg-white py-20 sm:py-24" data-id="element-170" data-mp="21y965qirgx1s">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8" data-id="element-171" data-mp="21vvgjx6uod1m">
        <div className="flex flex-col gap-6 lg:flex-row lg:items-end lg:justify-between" data-id="element-172" data-mp="rbi37edvkg1p">
          <SectionHeading kicker={t.gallery.kicker} title={t.gallery.title} subtitle={t.gallery.subtitle} data-id="element-173" data-mp="waupny0u3l3r" />
          <a href={business.instagramHref} target="_blank" rel="noreferrer" className="inline-flex items-center gap-2 self-start text-sm font-semibold text-brand-blue transition-colors duration-150 hover:text-navy lg:self-auto" data-id="element-174" data-mp="114qi6kybwfrj">
            <InstagramIcon className="h-4 w-4" aria-hidden="true" data-id="element-175" data-mp="dew6i6pqwx8v" />
            {t.gallery.more}
          </a>
        </div>

        <div className="mt-8 flex flex-wrap gap-2" role="tablist" aria-label={t.gallery.title} data-id="element-176" data-mp="mdgeodxojoiu">
          {filters.map(item => {
          const active = filter === item.id;
          return <button key={item.id} type="button" role="tab" aria-selected={active} onClick={() => setFilter(item.id)} className={`rounded-full px-4 py-2 text-sm font-semibold transition-colors duration-150 ${active ? 'bg-navy text-white' : 'bg-mist text-ink/70 hover:bg-navy/10 hover:text-navy'}`} data-id="element-177" data-mp="1xsd8e14t71wj">
                {item.label}
              </button>;
        })}
        </div>

        <div className="mt-8 grid gap-6 md:grid-cols-2" data-id="element-178" data-mp="3b2xlr5gvphmt">
          {visible.map(item => <figure key={item.id} className="flex flex-col" data-id="element-179" data-mp="364491f9f1unp">
              <BeforeAfter before={item.before} after={item.after} alt={item.alt[lang]} beforeLabel={t.gallery.before} afterLabel={t.gallery.after} sliderLabel={t.gallery.sliderLabel} hint={t.gallery.hint} data-id="element-180" data-mp="3kvv8jnswlsr8" />
              <figcaption className="mt-3 flex items-baseline justify-between gap-4" data-id="element-181" data-mp="2ndldq8xaffm3">
                <span className="font-display text-base font-bold text-navy" data-id="element-182" data-mp="12wc76p8gik48">
                  {item.title[lang]}
                </span>
                <span className="text-xs font-medium text-ink/60" data-id="element-183" data-mp="tx8npk5do2p7">{item.vehicle}</span>
              </figcaption>
            </figure>)}
        </div>
      </div>
    </section>;
}